/**
 * InfinitSales - Campaign Service (Fase 2)
 * Wrapper REST para o CampaignDispatcher do backend.
 * Lista, detalha e cancela campaign_runs criados via /api/labels/.../dispatch
 * quando o volume justifica passar pelo dispatcher dedicado.
 */
import api from './api';

const BASE = '/api/campaigns';

class CampaignService {
  /**
   * Lista campanhas do usuario (mais recente primeiro). Sem recipients_queue.
   * @param {object} opts
   *   - status?: 'queued'|'running'|'paused'|'completed'|'failed'|'cancelled'
   *   - limit?: number (default 50, max 200)
   */
  async list({ status, limit } = {}) {
    const params = {};
    if (status) params.status = status;
    if (limit) params.limit = limit;
    const response = await api.get(BASE, { params });
    return response.data;
  }

  /**
   * Detalhe completo de uma campanha, incluindo recipients_queue
   * com status individual de cada contato.
   */
  async get(runId) {
    const response = await api.get(`${BASE}/${runId}`);
    return response.data;
  }

  /**
   * Cancela campanha em andamento. Worker detecta no proximo chunk e para;
   * envios ja em voo terminam normalmente.
   */
  async cancel(runId) {
    const response = await api.post(`${BASE}/${runId}/cancel`);
    return response.data;
  }

  /**
   * Acompanhamento paginado (Etapa 4): pagina de destinatarios com busca por
   * telefone/nome, filtros de status/entrega e motivo em portugues.
   */
  async recipients(runId, { skip = 0, take = 50, q, status, delivery } = {}) {
    const params = { skip, take };
    if (q) params.q = q;
    if (status) params.status = status;
    if (delivery) params.delivery = delivery;
    const response = await api.get(`${BASE}/${runId}/recipients`, { params });
    return response.data;
  }

  /** CSV do filtro atual do acompanhamento. Retorna um Blob. */
  async exportRecipients(runId, { q, status, delivery } = {}) {
    const params = {};
    if (q) params.q = q;
    if (status) params.status = status;
    if (delivery) params.delivery = delivery;
    const response = await api.get(`${BASE}/${runId}/recipients/export`, {
      params, responseType: 'blob',
    });
    return response.data;
  }
}

const campaignService = new CampaignService();
export default campaignService;
